import {watchAnimations} from '../utility/init-gsap';

class TD_POST_FEED {
  constructor(feedEl) {
    this.setBlockElements(feedEl);
    
    this.setQueryVarsOnLoad();
    this.setFilterFromUrl();

    this.watchEvents();
  }

  setBlockElements(feedEl) {
    this.els = {};
    this.els.block = feedEl;
    this.els.count = this.els.block.querySelector('.post_feed__count_num');
    this.els.filters = this.els.block.querySelectorAll('.post_feed__filter');
    this.els.feedWrap = this.els.block.querySelector('.post_feed__list');
    this.els.loadMoreButton = this.els.block.querySelector('.post_feed__load_more');
    this.setCardElements();
  }

  /**
   * Set Card Elements
   */
  setCardElements(){
    this.els.cards = this.els.feedWrap.querySelectorAll('.card');
  }

  setQueryVarsOnLoad() {
    this.originalQueryVars = this.els.block.dataset; // Keep track of the original state
    this.queryVars = { ...this.els.block.dataset }; // Available for manipulation

    if(!this.queryVars.activeCategoryId){
      this.queryVars.activeCategoryId = '0';
    }
  }

  watchEvents(){
    if(this.els.loadMoreButton){
      this.els.loadMoreButton.addEventListener('click', () => {
        this.ajaxLoadMore(true);
      });
    }

    if(this.els.filters.length){
      this.els.filters.forEach(filter => {
        filter.addEventListener('click', () => {
          const nextCategoryId = filter.dataset.categoryId || '0';

          if(this.queryVars.activeCategoryId === nextCategoryId){
            return;
          }

          this.queryVars.activeCategoryId = nextCategoryId;
          this.setActiveFilterState();
          this.updateUrlWithActiveCategory();
          this.ajaxLoadMore(false);
        });
      });
    }
  }

  setFilterFromUrl(){
    if(!this.els.filters.length){
      return;
    }

    const url = new URL(window.location.href);
    const categorySlug = url.searchParams.get('category');
    if(!categorySlug){
      return;
    }

    const matchingFilter = [...this.els.filters].find(filter => {
      return (filter.dataset.categorySlug || '') === categorySlug;
    });

    if(!matchingFilter){
      return;
    }

    this.queryVars.activeCategoryId = matchingFilter.dataset.categoryId || '0';
    this.setActiveFilterState();
    this.ajaxLoadMore(false);
  }

  updateUrlWithActiveCategory(){
    const url = new URL(window.location.href);

    if(this.queryVars.activeCategoryId === '0'){
      url.searchParams.delete('category');
    }
    else {
      const activeFilter = [...this.els.filters].find(filter => {
        return (filter.dataset.categoryId || '0') === this.queryVars.activeCategoryId;
      });
      const activeSlug = activeFilter ? activeFilter.dataset.categorySlug : '';

      if(activeSlug){
        url.searchParams.set('category', activeSlug);
      }
      else {
        url.searchParams.delete('category');
      }
    }

    window.history.replaceState({}, '', url.toString());
  }

  setActiveFilterState(){
    if(!this.els.filters.length){
      return;
    }

    this.els.filters.forEach(filter => {
      const isActive = (filter.dataset.categoryId || '0') === this.queryVars.activeCategoryId;
      filter.classList.toggle('is_active', isActive);
      filter.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  /*****************************************************
   * AJAX CALL
   *****************************************************/
  ajaxLoadMore(loadMore = false) {
    // If we're not loading more posts but instead filtering posts, 
    // start a new query.
    if(!loadMore){
      this.queryVars.offset = 0;
    }
    else {
      this.queryVars.offset = this.els.cards.length;
    }

    var data = {
      action: 'ajax_filter_posts', // function to execute
      afp_nonce: afp_vars.afp_nonce, // wp_nonce
      queryVars: this.queryVars, // data used to execute new wp_query
    };

    document.body.classList.add('ajax_loading_posts');

    document.body.insertAdjacentHTML('beforeend','<div class="lds-ellipsis__wrap"><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div></div>');

    // console.log(this.queryVars);

    jQuery.post(afp_vars.afp_ajax_url, data, (response) => {
      if (response) {
        // console.log(response);

        // Update cards markup
        if(response.data.cards){
          // If the no results message is present, remove it.
          if(this.els.noResults){
            this.els.noResults.remove(); 
            this.els.noResults = null;
          }

          // Add new cards
          if(loadMore){
            this.els.feedWrap.insertAdjacentHTML( 'beforeend', response.data.cards );
          }
          else {
            this.els.feedWrap.innerHTML = response.data.cards;
          }
          
          // Track cards
          this.setCardElements();
          
          // For better keyboard accessibility, set focus on the "next" card, 
          // or first one if we're replacing all cards.
          const focusCard = this.queryVars.offset > 0 ? this.els.cards[this.queryVars.offset - 1] : this.els.cards[0];
          const focusCardLinks = focusCard ? focusCard.querySelectorAll('a') : null;
          if(focusCardLinks.length > 0){
            const focusLink = this.queryVars.offset > 0 ? focusCardLinks[focusCardLinks.length - 1] : focusCardLinks[0];
            focusLink.focus();
            focusLink.blur();
          }

          if(this.els.feedWrap.classList.contains('hidden')){
            this.els.feedWrap.classList.remove('hidden');
          }
        }
        else if(response.data.noResultsMarkup && !this.els.noResults) {
          this.els.feedWrap.innerHTML = '';
          this.els.block.insertAdjacentHTML('beforeend', response.data.noResultsMarkup);
          this.els.noResults = this.els.block.querySelector('.post_feed__no_results');
          this.setCardElements();
        }

        if(this.els.count && response.data.totalCount !== undefined){
          this.els.count.textContent = response.data.totalCount;
        }

        // Update the offset of the query vars
        this.queryVars.offset = this.els.cards.length ? this.els.cards.length : 0;

        // Determine if we should show/hide the load more button
        if(this.els.loadMoreButton){
          if(this.els.cards.length >= response.data.totalCount){
            this.els.loadMoreButton.setAttribute('disabled', '');
          }
          else if(this.els.loadMoreButton.getAttribute('disabled') !== null){
            this.els.loadMoreButton.removeAttribute('disabled');
          }
        }
      }
    }).done(() => {
    }).fail(() => {
    }).always(() => {
      document.body.classList.remove('ajax_loading_posts');
      const loadingGraphic = document.querySelector('.lds-ellipsis__wrap');
      if(loadingGraphic){
        loadingGraphic.remove();
      }

      // Call window resize event to trigger scroll trigger animations if needed
      setTimeout(() => {
        watchAnimations();
        const event = new CustomEvent("resize");
        window.dispatchEvent(event);
      }, 100);
    });
  }
}

export const initializePostFeeds = (event) => {
  const feeds = document.querySelectorAll('.post_feed');
  if(feeds.length){
    feeds.forEach(feed => {
      feed.postFeed = new TD_POST_FEED(feed);
    });
  }
};

function camelToKebabCase(str) {
  return str
    // Replace any lowercase letter followed by an uppercase letter with the lowercase letter, a hyphen, and the uppercase letter
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    // Convert the whole string to lowercase
    .toLowerCase();
}

function camelToUnderscoreCase(str) {
  return str
    // Replace any lowercase letter followed by an uppercase letter with the lowercase letter, a hyphen, and the uppercase letter
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    // Convert the whole string to lowercase
    .toLowerCase();
}